import { render, staticRenderFns } from "./ViewRestrictedArea.vue?vue&type=template&id=42d7c931&scoped=true"
import script from "./ViewRestrictedArea.vue?vue&type=script&lang=js"
export * from "./ViewRestrictedArea.vue?vue&type=script&lang=js"
import style0 from "./ViewRestrictedArea.vue?vue&type=style&index=0&id=42d7c931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7c931",
  null
  
)

export default component.exports